import { ContainerBackground, Title } from "./style";

interface Props {
  children: any;
  titulo: string;
}

export function Container({ children, titulo }: Props) {
  return (
    <ContainerBackground>
      <Title>{titulo}</Title>
      <hr />
      {children}
    </ContainerBackground>
  );
}
